import { DimCodeName } from "api";
import { services } from "contexts/ServiceContext";

export const mapDimCodeNameToSelectOption = (
  value: DimCodeName
): SelectOption => ({
  label: value.Name ?? "",
  value: value.Code ?? "",
});

export const getRequestContractQueryOptions = (
  cardCode: string | undefined,
  itemCode: string | undefined
) => ({
  queryKey: ["get-request-contract-select-options", { cardCode, itemCode }],
  queryFn: () => {
    return cardCode !== undefined && itemCode !== undefined
      ? services.contractService.getRequestContractSelectOptions(
          cardCode,
          itemCode
        )
      : Promise.reject();
  },
});
